export const AUTH_CONFIG = {
  domain: 'statelo.auth0.com',
  clientId: 'NxeS0ckKMKTCtqKvr6QMavmxPzdGHJiI',
  callbackUrl: window.location.origin + '/callback'
}